import CollapseItem from './src/collapse-item.vue'
import Collapse from './src/collapse.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToCollapse: SFCWithInstall<typeof Collapse> = withInstall(Collapse)

export const ToCollapseItem: SFCWithInstall<typeof CollapseItem> = withInstall(CollapseItem)

export * from './src/instance'
